import React, { useCallback } from 'react'
import { closeIcon } from '../../icons'
import './DetailModalCommon.css'
import QrTagEventRecorder from '../qr_tags/QrTagEventRecorder'

type Props = {
  closeModalFunction: (arg: any | void) => void
  modalProps: {
    group: IGroup
    onCompleted: () => Promise<void> | void
  }
}

const QrTagEventScannerModal = ({
  closeModalFunction,
  modalProps,
}: Props) => {
  const { group, onCompleted } = modalProps

  const handleEventCreated = useCallback(async () => {
    await onCompleted()
    closeModalFunction(undefined)
  }, [onCompleted, closeModalFunction])

  return (
    <div className="detail-modal-container" data-testid="qr-tag-scanner-modal">
      <div className="overlay" onClick={closeModalFunction} />
      <div className="detail-base">
        <div className="scrollable">
          <div className="title-row">
            <div className="detail-title">
              QRタグイベント登録
            </div>
            <div>
              <button
                onClick={closeModalFunction}
                className="close-button"
                type="button"
              >
                <img
                  src={closeIcon}
                  alt="close-button"
                />
              </button>
            </div>
          </div>
          <QrTagEventRecorder
            group={group}
            onEventCreated={handleEventCreated}
          />
        </div>
      </div>
    </div>
  )
}

export default QrTagEventScannerModal
